module.exports = __webpack_public_path__ + "img/danger-ac.f10e164b.svg";